import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  useColorModeValue
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const bg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const containerBg = useColorModeValue('gray.50', 'gray.900');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const headingColor = useColorModeValue('purple.600', 'purple.300');

  return (
    <Box minH="100vh" bg={containerBg}>
      <Container maxW="4xl" py={8}>
        <VStack spacing={6} align="stretch">
          <Box textAlign="center">
            <Button 
              onClick={() => navigate('/')} 
              colorScheme="purple" 
              variant="outline"
              mb={4}
            >
              ← {t('back')}
            </Button>
            <Heading as="h1" size="xl" color={headingColor} mb={2}>
              {t('terms.title')}
            </Heading>
            <Text color={textColor}>
              {t('terms.lastUpdated')}: 22 juillet 2025
            </Text>
          </Box>

          <Box bg={bg} p={6} borderRadius="lg" border="1px" borderColor={borderColor} shadow="sm">
            <VStack spacing={4} align="stretch">
              
              <Box>
                <Heading as="h2" size="lg" mb={3} color={headingColor}>
                  {t('terms.section1.title')}
                </Heading>
                <Text color={textColor}>{t('terms.section1.content')}</Text>
              </Box>

              <Box>
                <Heading as="h2" size="lg" mb={3} color={headingColor}>
                  {t('terms.section2.title')}
                </Heading>
                <Text mb={2} color={textColor}>{t('terms.section2.content')}</Text>
                <Text as="ul" pl={4} color={textColor}>
                  <Text as="li">• {t('terms.section2.rule1')}</Text>
                  <Text as="li">• {t('terms.section2.rule2')}</Text>
                  <Text as="li">• {t('terms.section2.rule3')}</Text>
                  <Text as="li">• {t('terms.section2.rule4')}</Text>
                </Text>
              </Box>

              <Box>
                <Heading as="h2" size="lg" mb={3} color={headingColor}>
                  {t('terms.section3.title')}
                </Heading>
                <Text color={textColor}>{t('terms.section3.content')}</Text>
              </Box>

              <Box>
                <Heading as="h2" size="lg" mb={3} color={headingColor}>
                  {t('terms.section4.title')}
                </Heading>
                <Text color={textColor}>{t('terms.section4.content')}</Text>
              </Box>

              <Box>
                <Heading as="h2" size="lg" mb={3} color={headingColor}>
                  {t('terms.section5.title')}
                </Heading>
                <Text color={textColor}>{t('terms.section5.content')}</Text>
              </Box>

              <Box>
                <Heading as="h2" size="lg" mb={3} color={headingColor}>
                  {t('terms.section6.title')}
                </Heading>
                <Text color={textColor}>{t('terms.section6.content')}</Text>
              </Box>

              <Box>
                <Heading as="h2" size="lg" mb={3} color={headingColor}>
                  {t('terms.section7.title')}
                </Heading>
                <Text color={textColor}>{t('terms.section7.content')}</Text>
              </Box>

              <Box>
                <Heading as="h2" size="lg" mb={3} color={headingColor}>
                  {t('terms.section8.title')}
                </Heading>
                <Text color={textColor}>{t('terms.section8.content')}</Text>
              </Box>

            </VStack>
          </Box>

          <Box textAlign="center">
            <Text fontSize="sm" color={textColor}>
              {t('terms.contact')}: contact@quizvs.com
            </Text>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default TermsOfService;
